// Chakra imports
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, SimpleGrid, useColorModeValue } from '@chakra-ui/react';
import FormContaFinanceiro from './components/FormContaFinanceiro';
import ContaFinanceiroTable from './components/Table';
import useContaFinanceiro from './hooks/useContaFinanceiro';



 const  ContaFinanceiro = () => {

	const textColor = useColorModeValue("navy.700", "white");
	const brandStars = useColorModeValue("brand.500", "brand.400");

	const {
		add,
		cancelRef,
		closeDelete,
		contaFinanceiroLista,
		deletar,
		error,
		loading,
		onChangeSelectedConta,
		save,
		selectedConta,
		show,
		showDelete,
		showDeleteModal,
		tipoConta,
		edit,
		changeInput,
		closeError,
		errorMsg,
		errorTitle,
		accountSelected,
		showModal,
		filiais,
		onChangeFilial,
		selectedFilial,
	} = useContaFinanceiro();

	return (
		<Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
		<SimpleGrid mb='20px' spacing={{ base: '20px', xl: '20px' }}>
			<ContaFinanceiroTable
				add={add}
				cancelRef={cancelRef}
				closeDelete={closeDelete}
				deletar={showDeleteModal}
				edit={edit}
				list={contaFinanceiroLista}
				remove={deletar}
				showDelete={showDelete}
			/>
		</SimpleGrid>
		<FormContaFinanceiro
			accountSelected={accountSelected}
			brandStars={brandStars}
			changeInput={changeInput}
			loading={loading}
			onChangeSelectedConta={onChangeSelectedConta}
			save={save}
			show={show}
			showModal={showModal}
			textColor={textColor}
			tipoConta={tipoConta}
			selectedConta={selectedConta}
			filiais={filiais}
			onChangeFilial={onChangeFilial}
			selectedFilial={selectedFilial}
				

		/>

        <AlertDialog
          isOpen={error}
          leastDestructiveRef={cancelRef}
          onClose={closeError}
          isCentered
          motionPreset="slideInBottom"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {errorTitle}
              </AlertDialogHeader>

              <AlertDialogBody>{errorMsg}</AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  onClick={closeError}
                  colorScheme={"blue"}
                >
                  OK
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
	</Box>
	);
}

export default ContaFinanceiro;
